import Dashboard from 'components/dashboard/ManageDashboardPage';
import ImportDataPage from 'components/importData/ImportDataPage';
import ManageImportProfilePage from 'components/importProfile/ManageImportProfilePageConnector';
import ManageRules from 'components/manageRules/ManageRulesPage';
import ManageAllocationUnits from 'components/manageAllocationUnits/ManageAllocationUnitsPage';
import ManageCostObjects from 'components/manageCostObjs/ManageCostObjsPage';
import ViewTransactions from 'components/viewTransactions/ViewTransactionsPage';
import ManageConnections from 'components/manageConnection/ManageConnectionPage';
import ManageReports from 'components/manageReports/ManageReportsPage';
import OrgCreation from 'components/orgCreation/OrgCreationPage';
import {
  UTM_C_PROFILE,
  UTM_R_PROFILE,
  UTM_R_ALLOCATIONUNIT,
  UTM_R_COSTOBJECT,
  UTM_R_RULE,
  UTM_R_REPORT,
  UTM_R_TRANSACTION,
  UTM_R_LINES,
  UTM_R_SFTPCREDENTIAL,
  UTM_R_ORGANIZATION
} from 'shared/constants/PermissionsConstants';

import {
  FormatListBulleted,
  AccountBalance,
  Redo,
  FolderOpen, 
  InsertChartOutlined,
  Receipt,
  Settings
} from '@material-ui/icons';

const hiddenRoutes =  [
  {
    label: 'Update Import Profile',
    path: 'edit-import-profile',
    component: ManageImportProfilePage
  }
];

const routes = [

  {
    label: 'Dashboard',
    path: 'dashboard',
    component: Dashboard,
    icon: InsertChartOutlined
  },
  {
    label: 'Import',
    icon: Redo,
    nestedRoutes: [
      {
        label: 'New Import Profile',
        path: 'new-import-profile',
        component: ManageImportProfilePage,
        requiredPermissions: UTM_C_PROFILE
      },
      {
        label: 'Import Data',
        path: 'import-data',
        component: ImportDataPage,
        requiredPermissions: UTM_R_PROFILE
      }
    ]
  },
  {
    label: 'Data Rules',
    icon: AccountBalance,
    nestedRoutes: [
      {
        label: 'Manage Rules',
        path: 'manage-rules',
        component: ManageRules,
        requiredPermissions: UTM_R_RULE
      },
      {
        label: 'Manage Cost Objects',
        path: 'manage-cost-objects',
        component: ManageCostObjects,
        requiredPermissions: UTM_R_COSTOBJECT
      },
      {
        label: 'Custom Allocation Units',
        path: 'manage-allocation-units',
        component: ManageAllocationUnits,
        requiredPermissions: UTM_R_ALLOCATIONUNIT
      },

    ]
  },
  {
    label: 'View Transactions',
    path: 'view-transactions',
    component: ViewTransactions,
    icon: FormatListBulleted,
    requiredPermissions: [UTM_R_TRANSACTION, UTM_R_LINES]
  },
  {
    label: 'Reports',
    path: 'reports',
    component: ManageReports,
    icon: Receipt,
    requiredPermissions: UTM_R_REPORT
  },
  {
    label: 'Manage Connections',
    path: 'manage-connections',
    component: ManageConnections,
    icon: FolderOpen,
    requiredPermissions: UTM_R_SFTPCREDENTIAL
  },
  {
    label: 'Settings',
    path: 'settings',
    component: OrgCreation,
    icon: Settings,
    requiredPermissions: UTM_R_ORGANIZATION
  }

];

export {
  routes, 
  hiddenRoutes
};



// WEBPACK FOOTER //
// ./src/components/app/Routes.js